var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['level', ("level-" + _vm.levelCount)]},[_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.$slots.default),expression:"$slots.default"}]},[_vm._t("default")],2),_vm._t("metanavigation")],2)}
var staticRenderFns = []

export { render, staticRenderFns }